import { withStyles } from "@material-ui/core";
import { Column, Flex, FormSelect, Input, Option } from "lqx-react/lib";
import * as React from 'react';
import NumberFormat from "react-number-format";
import { getCompanies } from "../../api/company";
import { ManualUnappliedCash, UnappliedCash } from "../../api/unappliedCash";
import { StyledFormLabel, numberInputStyles } from "../../components/number-input";
import { DigiAsyncSelect, DigiCurrencySelect } from "../../components/select";
import { DigiDateInput, ErrorHighligter, asTimelessLinkedDate } from "../../shared";
import { globalStore } from "api/store";


export const UnappliedCashForm = ({ unappliedCash }: { unappliedCash: UnappliedCash | ManualUnappliedCash }) => {
    const classes = numberInputStyles();
    //const currencies = ["USD", "SGD", "GBP", "CAD", "EUR", "AUD", "MXN"];

    return <>
        <Flex row>
            <Column>
                <StyledFormLabel>Payor</StyledFormLabel>
                <ErrorHighligter error={unappliedCash.warnings[`payor`]}>
                    <DigiAsyncSelect
                        aria-label="Payor"
                        data-qa-id={`company payor`}
                        getItems={getCompanies}
                        $value={unappliedCash.payor.$.company}
                    />
                </ErrorHighligter>
            </Column>
        </Flex>
        <br />
        <Flex row>
            <Column>
                <StyledFormLabel>Payee</StyledFormLabel>
                <ErrorHighligter error={unappliedCash.warnings[`payee`]}>
                    <DigiAsyncSelect
                        aria-label="Payee"
                        data-qa-id={`company payee`}
                        getItems={getCompanies}
                        $value={unappliedCash.payee.$.company}
                    />
                </ErrorHighligter>
            </Column>
        </Flex>
        <br />
        <Flex row>
            <Column>
                <StyledFormLabel>Currency</StyledFormLabel>
                <ErrorHighligter error={unappliedCash.errors['currency']}>
                    <DigiCurrencySelect
                        aria-label="Currency"
                        isMulti={false}
                        options={globalStore.currenciesLookup.items.models}
                        $value={unappliedCash.$.currency}
                    />
                </ErrorHighligter>
            </Column>
            <Column>
                <StyledFormLabel>Amount</StyledFormLabel>
                <ErrorHighligter error={unappliedCash.errors['amount']}>
                    <NumberFormat
                        aria-label="Amount"
                        data-qa-id="amount"
                        value={unappliedCash.amount}
                        className={classes.numericInput}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        onValueChange={(values) => {
                            const { floatValue } = values;
                            unappliedCash.$.amount.set(floatValue)
                        }} />
                </ErrorHighligter>
            </Column>
            <Column>
                <StyledFormLabel>Effective Date</StyledFormLabel>
                <ErrorHighligter error={unappliedCash.errors['effectiveDate']}>
                    <DigiDateInput data-qa-id="effective date" date $value={asTimelessLinkedDate(unappliedCash.$.effectiveDate)} />
                </ErrorHighligter>
            </Column>
            <Column>
                <StyledFormLabel>Reference Number</StyledFormLabel>
                <ErrorHighligter error={unappliedCash.errors['referenceNumber']}>
                    <Input data-qa-id="reference number" $value={unappliedCash.$.referenceNumber} aria-label="Reference Number" />
                </ErrorHighligter>
            </Column>
        </Flex>
    </>;
}

const FormSelectContainer = withStyles({
    root: {
        marginTop: 4,
        marginBottom: 0,
    },
    selectInput: {
        padding: 5.9
    }
})(FormSelect);